//**auto-generated don't edit this code**//
export enum TotalReportType {
	None,
	District,
	School,
	Class,
	Group,
	StudentsSchool,
	StudentsDistrict,
	Teacher,
	SpecialistGroup,
	SchoolSpecialist,
	SchoolSpecialistStudents,
	DistrictSpecialist,
	DistrictSpecialistStudents,
	DistrictPreassessStudents,
	DistrictPreassess,
	SchoolsGroup,
	TeachersGroup,
	StudentsSchoolsGroup,
	StudentsTeachersGroup,
	GroupOfSpecialists,
	GroupOfSpecialistsStudents,
}